import { MAGNITT_ACCESS_ROLES } from "./userRoles";

const redirectHandlers = {

    // original path : /client-directory
    ClientDirectory: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.custom_directory_access) ? {
            redirectPath: '/startups',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Custom Directory"
        } : null,

    // original path : /dashboards
    SavedSearchDashBoard: ({ is_loggedin = false } = {}) => !is_loggedin ? {
        redirectPath: '/',
        reason: "not_logged_in",
        pageName: "Saved Views"
    } : null,

    // original path : /mysettings
    AccountSettings: ({ is_loggedin = false } = {}) => !is_loggedin ? {
        redirectPath: '/',
        reason: "not_logged_in",
        pageName: "Account Settings"
    } : null,

    // Analytics routes (require custom analytics access)
    // original path : /analytics/:slug (require user to belong to the organization)
    CustomAnalyticsPage: ({ is_loggedin = false, roles = [], customAnalyticsDashboard = [] } = {}, path) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.custom_analytics_access) || !customAnalyticsDashboard.some(item => item.link === path) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Custom Charts"
        } : null,

    // original path : /analytics/startup-analysis
    StartupAnalyticsPage: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.advanced_analytics_access) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Startup Analysis"
        } : null,

    // original path : /analytics/market-sizing
    MarketSizingPage: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.advanced_analytics_access) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Market Sizing"
        } : null,

    // original path : /analytics/deal-size
    DealSizeAnalysisPage: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.advanced_analytics_access) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Deal Size Analysis"
        } : null,

    // original path : /analytics/geography
    GeoBenchmarkPage: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.advanced_analytics_access) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Geographic Benchmarking"
        } : null,

    // original path : /analytics/industry
    IndustryBenchmarkPage: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.advanced_analytics_access) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Industry Benchmarking"
        } : null,

    // original path : /analytics/investor-ranking
    InvestorRankingPage: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.advanced_analytics_access) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Investor Ranking"
        } : null,

    // original path : /analytics/exits
    ExitAnalysisPage: ({ is_loggedin = false, roles = [] } = {}) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.advanced_analytics_access) ? {
            redirectPath: '/advanced-analytics',
            reason: !is_loggedin ? "not_logged_in" : "access_denied",
            pageName: "Exit Analysis"
        } : null,

    // original path : /private-equity
    PrivateEquityDirectory: ({ is_loggedin = false, roles = [] } = {}, Component) =>
        !is_loggedin || (!roles.includes(MAGNITT_ACCESS_ROLES.directory_access) && !roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))
            ? {
                redirectComponent: Component,
                reason: !is_loggedin ? "not_logged_in" : "access_denied",
                path: '/private-equity',
                pageName: "Private Equity Directory"
            } : null,

    Startup: ({ is_loggedin = false, roles = [] } = {}, Component) =>
        !is_loggedin || (!roles.includes(MAGNITT_ACCESS_ROLES.directory_access) && !roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))
            ? {
                redirectComponent: Component,
                reason: !is_loggedin ? "not_logged_in" : "access_denied",
                path: '/startup',
                pageName: "Startups Directory"
            } : null,

    Company: ({ is_loggedin = false, roles = [] } = {}, Component) =>
        !is_loggedin || (!roles.includes(MAGNITT_ACCESS_ROLES.directory_access) && !roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))
            ? {
                redirectComponent: Component,
                reason: !is_loggedin ? "not_logged_in" : "access_denied",
                path: '/companies',
                pageName: "Company Directory"
            } : null,

    Investor: ({ is_loggedin = false, roles = [] } = {}, Component) =>
        !is_loggedin || (!roles.includes(MAGNITT_ACCESS_ROLES.directory_access) && !roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))
            ? {
                redirectComponent: Component,
                reason: !is_loggedin ? "not_logged_in" : "access_denied",
                path: '/investor',
                pageName: "Investors Directory"
            } : null,

    // original path : /investors-and-funds (the Investors & Funds directory under test, admins only for now): everyone else goes to /investors
    // redirectPath is for the server (getRedirectPath), redirectComponent for the client (getRedirectComponent, pass the component)
    InvestorDev: ({ is_loggedin = false, roles = [] } = {}, Component) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.admin_access)
            ? {
                redirectPath: '/investors',
                redirectComponent: Component,
                reason: !is_loggedin ? "not_logged_in" : "restricted_access",
                path: '/investors-and-funds',
                pageName: "Investors & Funds (test version)"
            } : null,

    // original path : /limited-partners (the LP directory under test, admins only for now, as /investors-and-funds): everyone else goes to /investors
    Lps: ({ is_loggedin = false, roles = [] } = {}, Component) =>
        !is_loggedin || !roles.includes(MAGNITT_ACCESS_ROLES.admin_access)
            ? {
                redirectPath: '/investors',
                redirectComponent: Component,
                reason: !is_loggedin ? "not_logged_in" : "restricted_access",
                path: '/limited-partners',
                pageName: "LP Directory"
            } : null,

    Funds: ({ is_loggedin = false, roles = [] } = {}, Component) =>
        !is_loggedin || (!roles.includes(MAGNITT_ACCESS_ROLES.directory_access) && !roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))
            ? {
                redirectComponent: Component,
                reason: !is_loggedin ? "not_logged_in" : "access_denied",
                path: '/funds',
                pageName: "Funds Directory"
            } : null,

};

export default redirectHandlers;
